import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { 
  ODataClient,
  ODataEntityService, 
  ODataEntity, 
  ODataEntities, 
  ODataProperty, 
  EntityKey,
  Duration,
  ODataEntityResource,
  ODataEntitySetResource,
  ODataNavigationPropertyResource,
  ODataActionResource,
  ODataFunctionResource,
  HttpOptions
} from 'angular-odata';

//#region ODataApi Imports
import { KundeDto } from '../entities/kundedto.entity';
import { KundenFilterDto } from '../Mza/Entities/Dtos/kundenfilterdto.entity';
import { WettbewerberPreisViewDto } from '../Mza/Service/Controllers/V1/Kunden/Models/wettbewerberpreisviewdto.entity';
//#endregion

@Injectable()
export class KundenService extends ODataEntityService<KundeDto> {
  constructor(protected client: ODataClient) {
    super(client, 'Kunden', 'entities.KundeDto');
  }

  
  
  //#region ODataApi Actions
  //#endregion
  //#region ODataApi Functions
  public inputFilter(): ODataFunctionResource<{value: string}, KundenFilterDto> {
    const resource = this.entities().function<{value: string}, KundenFilterDto>('entities.customers.InputFilter');
    return resource;
  }
  public getWettbewerberPreise(): ODataFunctionResource<{groupId: number}, WettbewerberPreisViewDto> {
    const resource = this.entities().function<{groupId: number}, WettbewerberPreisViewDto>('services.GetWettbewerberPreise');
    return resource;
  }
  //#endregion
  //#region ODataApi Navigations
  //#endregion
}
